import React, { useEffect, useState } from "react";
import DatePopUp from "./date_popup.js";
import "../styles/history_popup.css";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import MaterialBox from "./materialBox.js";

const MaterialsCons = (props) => {
  const [hearings, setHearings] = useState([]);
  const [showDate, setShowDate] = useState(false);
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(true);

  const closeDatePopUp = (e) => {
    setShowDate(!showDate);
    setDate("");
    getData();
  };

  const showDatePopUp = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setDate(hearings.filter((el) => +el.id === +value)[0]);
    showDateP();
  };

  const showDateP = () => {
    setShowDate(true);
  };

  const fetchHearings = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getMaterialsConsultant", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHearings(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchHearings();
  };

  useEffect(() => {
    getData();
  }, []);

  const destopData = (
    <>
      <>
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="hearingTitle">
          Materiały ({hearings.length} rekordów)
        </div>
        <table style={{ marginTop: "5vh" }} className="clients_table">
          <tr key={0}>
            <th>Nazwa</th>
          </tr>
          {hearings.map((el) => (
            <>
              <tr id={""} key={el.identifier}>
                <td
                  style={{ textAlign: "left", padding: "10px" }}
                  value={el.id}
                  onClick={showDatePopUp}
                >
                  {el.name}
                </td>
              </tr>
            </>
          ))}
        </table>
      </>
    </>
  );

  const mobileData = (
    <>
      <>
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="hearingTitle">
          AKCEPTUJ TERMINY ROZPRAW ({hearings.length} rekordów)
        </div>
        <table style={{ marginTop: "5vh" }} className="clients_table">
          <tr key={0}>
            <th>Nazwa</th>
          </tr>
          {hearings.map((el) => (
            <>
              <tr id={""} key={el.identifier}>
                <td
                  style={{ textAlign: "left", padding: "10px" }}
                  value={el.id}
                  onClick={showDatePopUp}
                >
                  {el.name}
                </td>
              </tr>
            </>
          ))}
        </table>
      </>
    </>
  );

  return (
    <>
      {showDate ? (
        <>
          <MaterialBox closePopUp={closeDatePopUp} material={date} />
        </>
      ) : (
        ""
      )}
      {showDate ? (
        ""
      ) : (
        <div className="mainContainerDatePopUp">
          {loading ? (
            <Loading id="popUpLoading" />
          ) : (
            <>
              <div className="desktopFilters">{destopData}</div>
              <div className="mobileFilters">{mobileData}</div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default MaterialsCons;
